module.exports = __webpack_public_path__ + "img/banner.83ba9bf3.png";